// import "./modules/HelloWorld";

// Some cool modules
import "./modules/AjaxForm";
import "./modules/Animate";
import "./modules/ToggleBodyClass";
import "./modules/ScrollClass";
import "./modules/Dropdown";
import "./modules/Eyes";
import "./modules/CardSlider";
import "./modules/LargeCardSlider";
import "./modules/CardSliderNapadnik";
import "./modules/CardSliderGift";
import "./modules/Eshop";
import "./modules/Instagram";
import "./modules/NavCloser";
import "./modules/NavClass";
import "./modules/Tabs";
import "./modules/Accordion";
import "./modules/Fancybox";
import "./modules/Gift";
import "./modules/HeaderAnchor";
import DonationForm from "./modules/DonationForm";

// Initialize donation form
new DonationForm();
